module.exports = __webpack_public_path__ + "ca05cb3bf736d24226e4beb8f3323a56.pdf";